// PROPOSAL_STATUS_UNSPECIFIED 未指定
// PROPOSAL_STATUS_DEPOSIT_PERIOD 质押期
// PROPOSAL_STATUS_VOTING_PERIOD  进行中
// PROPOSAL_STATUS_PASSED 通过
// PROPOSAL_STATUS_REJECTED 未通过
// PROPOSAL_STATUS_FAILED 未通过
export type TProposalStatus =
  | 'PROPOSAL_STATUS_UNSPECIFIED'
  | 'PROPOSAL_STATUS_DEPOSIT_PERIOD'
  | 'PROPOSAL_STATUS_VOTING_PERIOD'
  | 'PROPOSAL_STATUS_PASSED'
  | 'PROPOSAL_STATUS_REJECTED'
  | 'PROPOSAL_STATUS_FAILED'
export const getStatus = (status: TProposalStatus, t: any) => {
  let text = ''
  switch (status) {
    // 未指定
    case 'PROPOSAL_STATUS_UNSPECIFIED':
      text = t('explorer_278')
      break
    // 质押期
    case 'PROPOSAL_STATUS_DEPOSIT_PERIOD':
      text = t('explorer_279')
      break
    // 进行中
    case 'PROPOSAL_STATUS_VOTING_PERIOD':
      text = t('explorer_272')
      break
    // 通过
    case 'PROPOSAL_STATUS_PASSED':
      text = t('explorer_273')
      break
    // 未通过
    case 'PROPOSAL_STATUS_REJECTED':
      text = t('explorer_274')
      break
    // 未通过
    case 'PROPOSAL_STATUS_FAILED':
      text = t('explorer_274')
      break
  }
  return text
}

export const getOptions = (status: string, t: any) => {
  let test = ''
  switch (status) {
    case 'VOTE_OPTION_YES':
      test = t('explorer_275')
      break
    case 'VOTE_OPTION_NO':
      test = t('explorer_276')
      break
    case 'VOTE_OPTION_NO_WITH_VETO':
      test = t('explorer_277')
      break
    case 'VOTE_OPTION_ABSTAIN':
      test = t('explorer_282')
      break
  }
  return test
}
